import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import Bg from '~/shared/assets/background/event-info-2.png'
import NoPage from '~/shared/assets/background/no-data.png'
import theme from '~/shared/styles/theme'

function NotFound() {
  const navigate = useNavigate()

  const [seconds, setSeconds] = useState(3)

  useEffect(() => {
    const countdown = setInterval(() => {
      setSeconds((prevSeconds) => prevSeconds - 1)
    }, 1000)

    const timer = setTimeout(() => {
      navigate('/')
    }, 3000)

    return () => {
      clearInterval(countdown)
      clearTimeout(timer)
    }
  }, [navigate])

  return (
    <Wrapper>
      <BackgroundImage src={Bg} alt="background image" />
      <Image src={NoPage} alt="Page Not Found" />
      <Message>{'페이지를 찾을 수 없습니다.'}</Message>
      <RedirectMessage>
        <Bold>{`${seconds}`}</Bold>
        {` 초 후 홈으로 이동합니다. `}
      </RedirectMessage>
    </Wrapper>
  )
}

export default NotFound

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  box-sizing: border-box;
  width: 100vw;
  max-width: 1080px;
  min-height: calc(100vh - ${theme.size.headerHeight}px);
  margin: 0 auto;
  margin-top: calc(80px + ${theme.size.headerHeight}px);
  margin-bottom: 120px;
`

const BackgroundImage = styled.img`
  position: absolute;
  z-index: ${theme.zIndex.belowBackground};
  top: 0;
  left: 0;

  overflow: hidden;

  width: 100%;
  height: 100%;

  background-repeat: no-repeat;

  @media ${theme.device.medium} {
    /* height: 100%; */
    background-repeat: repeat;
  }
`

const Image = styled.img`
  max-width: 100%;
  height: auto;
  margin-bottom: 20px;

  @media ${theme.device.medium} {
    margin-bottom: 20px;
  }
`

const Message = styled.p`
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 42px;
  font-weight: 500;

  @media ${theme.device.medium} {
    font-size: 28px;
  }
`

const RedirectMessage = styled.p`
  margin-top: 20px;
  font-family: NanumSquareNeo-Regular, sans-serif;
  font-size: 21px;
  font-weight: 500;

  @media ${theme.device.medium} {
    font-size: 16px;
  }
`

const Bold = styled.span`
  font-family: NanumSquareNeo-Bold, sans-serif;
  font-size: 32px;
  font-weight: bold;
  color: #8bd2d7;
`
